import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Line = styled.div`
  height: ${(props) => props.height || "auto"};
  width: ${(props) => props.width || "100%"};
  min-width: ${(props) => props.minWidth || "0"};
  border-radius: ${(props) => props.borderRadius || "0"};
  border-bottom: 1px solid rgba(234, 234, 234, 1);
`;
const LineOuter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.height || "0%"};
  width: ${(props) => props.width || "100%"};
  padding-left: ${(props) => props.paddingLeft || "10%"};
  padding-right: 10%;
  margin-top: -10px;
  margin-bottom: 20px;
  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
    `}
`; 
class LineAtom extends PureComponent {
  render() {
    return (
      <LineOuter
        width={this.props.width}
        paddingLeft={this.props.paddingLeft}
        onClick={this.props.onClick}
        cursor={this.props.cursor}
      >
        <Line
          src={this.props.src}
          onMouseOver ={this.props.onMouseOver}
          onMouseOut ={this.props.onMouseOut}
          width={this.props.imgwidth}
          minWidth={this.props.minWidth}
          borderRadius= {this.props.borderRadius}
        ></Line>
      </LineOuter>
    );
  }
}

export default LineAtom